export { default } from './IconLabel'
